import { orderQuery } from 'utils/queries'
import reduceOrders from 'modules/OrderHistory/helpers/reduceOrders'

const loadAttestOrders = async ({ path, graphql, props }) => {
  const result = await graphql.query(
    orderQuery({ status: 'UNDER_ATTEST', skip: 0, limit: 1000, withInfo: true })
  )

  const { orders } = result
  if (orders.count > 0) {
    return path.loaded({
      attestCount: orders.count,
      attestOrders: reduceOrders(orders.orders)
    })
  } else {
    return path.noAttestOrders()
  }
}

export default loadAttestOrders



// WEBPACK FOOTER //
// ./src/modules/App/actions/loadAttestOrders.js